export function getFinancialYears() {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth() + 1

  let currentFinancialYear
  if (currentMonth >= 4) {
    currentFinancialYear = {
      text: `${currentYear} Apr - ${currentYear + 1} Mar`,
      value: currentYear + 1,
    }
  } else {
    currentFinancialYear = {
      text: `${currentYear - 1} Apr - ${currentYear} Mar`,
      value: currentYear,
    }
  }

  const financialYears = [currentFinancialYear]
  for (let i = 1; i <= 4; i++) {
    const startYear = parseInt(currentFinancialYear.text.split(' ')[0])
    const newStartYear = startYear - i
    const newEndYear = newStartYear + 1
    financialYears.push({
      text: `${newStartYear} Apr - ${newEndYear} Mar`,
      value: newEndYear,
    })
  }

  financialYears.push({ text: 'None', value: '' })

  return financialYears
}

export function getFinancialYearByDate(dateString) {
  let date = new Date(dateString)
  let year = date.getFullYear()
  let month = date.getMonth() + 1

  if (month >= 4) {
    return { text: `${year} Apr - ${year + 1} Mar`, value: `${year + 1}` }
  } else {
    return { text: `${year - 1} Apr - ${year} Mar`, value: `${year}` }
  }
}
